import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnInputTemplateOptions } from './input-template-options.interface';

export interface ISnInputFormFieldConfig extends FormlyFieldConfig {
  type: 'input';
  templateOptions?: ISnInputTemplateOptions;
}
